
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91webpageId_93cVBDz4hocniWI_QdxlT3qTkqhX0MGIRV_A1A4EUUD28Meta } from "/app/app/pages/dashboard/webpages/client/[clientId]/website/[websiteId]/webpage/[webpageId].vue?macro=true";
import { default as webpage_bvMq61YNHcnQoknmPgPFKlWW6YibEUQTXtBBPyjisAMeta } from "/app/app/pages/dashboard/webpages/client/[clientId]/website/[websiteId]/webpage.vue?macro=true";
import { default as createIG92s7FUJ0oazTf0g3w7EqSyMYMnp4jhb0zkTAIDtbEMeta } from "/app/app/pages/dashboard/eventmodule/client/[id]/create.vue?macro=true";
import { default as indexFtjG89Bh8Ek9xDZ9L6_apmw_BeHZ7zEPsqgGPZjBh50Meta } from "/app/app/pages/dashboard/eventmodule/client/[id]/speakers/index.vue?macro=true";
import { default as event_45_91eventId_93NbdKzaBkb3XqDwiWomf7s0DYHl4JkK5JtcIAuPFFS8IMeta } from "/app/app/pages/dashboard/eventmodule/client/[id]/event-[eventId].vue?macro=true";
import { default as indexKFBdefzb0RxjmvR8_dSwdIQX_d8SuXgp3f7NxLfVWNwMeta } from "/app/app/pages/dashboard/eventmodule/client/[id]/index.vue?macro=true";
import { default as user_45management1w7QoGY7fbmyPFPyjsQDU82mPypw_HG7rTzaT9vzUe0Meta } from "/app/app/pages/dashboard/admin/user-management.vue?macro=true";
import { default as indexE2E0Vbc33pV7Hm4qnZqfdLpIQUEtYcAYaXSk7ckPu6AMeta } from "/app/app/pages/dashboard/stock/outofstock/index.vue?macro=true";
import { default as indexPEHsEG1vGqPO7LMvkTXIOI3QvhAVMlemZ6x_haeWzqsMeta } from "/app/app/pages/dashboard/tools/emm-flow/index.vue?macro=true";
import { default as _91userid_93L6E0Ns8RvDtjdqUwfdtJPSQ_kJY9MokPUepF_wdXCTcMeta } from "/app/app/pages/dashboard/webusers/[clientid]/[userid].vue?macro=true";
import { default as indexDjkFYUWD0bQAoG4VCBuKPVK7k2j8q3rNpOM0hhuod00Meta } from "/app/app/pages/dashboard/eventmodule/index.vue?macro=true";
import { default as indexMhkj4tVpyBiKL2bnJlPufVmTCai12fhGOtHtNbiDRngMeta } from "/app/app/pages/dashboard/pointshop/index.vue?macro=true";
import { default as settingst1x9BoSz_EDaMmivH1DyfFMJsYHhYNMDsNmAX4FLQowMeta } from "/app/app/pages/dashboard/seo/[domain]/settings.vue?macro=true";
import { default as seoqigIGxALwNFWRbXYw3xTGEk0fsfmvrIukDqCsrxg5uMMeta } from "/app/app/pages/dashboard/seo.vue?macro=true";
import { default as serversgumUUtIKuH0z6MvCnlaIRMTRFhfox0xj7iHzf8koPSQMeta } from "/app/app/pages/dashboard/servers.vue?macro=true";
import { default as indexqfQk3C5z_nf8Nlz1kffHvi0ZI3PleMffGJd4uKhAom8Meta } from "/app/app/pages/dashboard/tools/index.vue?macro=true";
import { default as indexHIIz5a6XrnVNDnYNer2S3TfuCfDTyCFLRX_fA_cl9DYMeta } from "/app/app/pages/dashboard/webevents/index.vue?macro=true";
import { default as indexpcFc3gBS2PuENZwWx1mByHJmTzlp3KOcHEtE_ZfWbIUMeta } from "/app/app/pages/dashboard/webforms/[domain]/editform/[id]/index.vue?macro=true";
import { default as createQbAnIyEL7yN7cAvlYpgbfP0NsdrZvniS1IPmDLjUDToMeta } from "/app/app/pages/dashboard/webforms/[domain]/create.vue?macro=true";
import { default as overviewfZEVZ2jwqsX9z5R3B3eblnhHp_ZbvOVaoMyxow3hBtEMeta } from "/app/app/pages/dashboard/webforms/[domain]/overview.vue?macro=true";
import { default as settingsq9qUg6pPz2ImpTb4cf28u_KBc7ZXuMnAoyrS_OluSKIMeta } from "/app/app/pages/dashboard/webforms/[domain]/settings.vue?macro=true";
import { default as webformsUYH_eHnzo7R84kr3YuMlYoI0kpGh88Q0axhL1l881q8Meta } from "/app/app/pages/dashboard/webforms.vue?macro=true";
import { default as indexzp_GCrkg6qjznHfxptlM1q6d6cwdEzDVNjWeftJFcMIMeta } from "/app/app/pages/dashboard/webpages/index.vue?macro=true";
import { default as newspdsd_Mn_sRdtTgiNi_X9fmbm0Ucxcq9RSRXk8rlwWnkMeta } from "/app/app/pages/dashboard/client-[clientID]/screens/newssetup/news.vue?macro=true";
import { default as newssetupZh354pPfdci5Brk8qO89dczyF7U3v_KpbZUIwrQ8_qgMeta } from "/app/app/pages/dashboard/client-[clientID]/screens/newssetup.vue?macro=true";
import { default as webeventsd0V7NoTGyasG7x9BTnKAPB2ROMPyBjxb4jSZhNnPYw0Meta } from "/app/app/pages/dashboard/client-[clientID]/screens/webevents.vue?macro=true";
import { default as LoginJvrAfz0lsVTnrj7IU6q5pajc3WOjYSVdzcpFNnOZZOIMeta } from "/app/app/pages/Login.vue?macro=true";
export default [
  {
    name: "dashboard-webpages-client-clientId-website-websiteId-webpage",
    path: "/dashboard/webpages/client/:clientId()/website/:websiteId()/webpage",
    meta: webpage_bvMq61YNHcnQoknmPgPFKlWW6YibEUQTXtBBPyjisAMeta || {},
    component: () => import("/app/app/pages/dashboard/webpages/client/[clientId]/website/[websiteId]/webpage.vue"),
    children: [
  {
    name: "dashboard-webpages-client-clientId-website-websiteId-webpage-webpageId",
    path: ":webpageId()",
    meta: _91webpageId_93cVBDz4hocniWI_QdxlT3qTkqhX0MGIRV_A1A4EUUD28Meta || {},
    component: () => import("/app/app/pages/dashboard/webpages/client/[clientId]/website/[websiteId]/webpage/[webpageId].vue")
  }
]
  },
  {
    name: "dashboard-eventmodule-client-id-create",
    path: "/dashboard/eventmodule/client/:id()/create",
    meta: createIG92s7FUJ0oazTf0g3w7EqSyMYMnp4jhb0zkTAIDtbEMeta || {},
    component: () => import("/app/app/pages/dashboard/eventmodule/client/[id]/create.vue")
  },
  {
    name: "dashboard-eventmodule-client-id-speakers",
    path: "/dashboard/eventmodule/client/:id()/speakers",
    meta: indexFtjG89Bh8Ek9xDZ9L6_apmw_BeHZ7zEPsqgGPZjBh50Meta || {},
    component: () => import("/app/app/pages/dashboard/eventmodule/client/[id]/speakers/index.vue")
  },
  {
    name: event_45_91eventId_93NbdKzaBkb3XqDwiWomf7s0DYHl4JkK5JtcIAuPFFS8IMeta?.name,
    path: "/dashboard/eventmodule/client/:id()/event-:eventId()",
    meta: event_45_91eventId_93NbdKzaBkb3XqDwiWomf7s0DYHl4JkK5JtcIAuPFFS8IMeta || {},
    component: () => import("/app/app/pages/dashboard/eventmodule/client/[id]/event-[eventId].vue"),
    children: [
  {
    name: "dashboard-eventmodule-client-id-event-eventId-sessions-sessionId",
    path: "sessions/:sessionId()",
    component: () => import("/app/app/pages/dashboard/eventmodule/client/[id]/event-[eventId]/sessions/[sessionId].vue")
  },
  {
    name: "dashboard-eventmodule-client-id-event-eventId-sessions",
    path: "sessions",
    component: () => import("/app/app/pages/dashboard/eventmodule/client/[id]/event-[eventId]/sessions/index.vue")
  },
  {
    name: "dashboard-eventmodule-client-id-event-eventId",
    path: "",
    component: () => import("/app/app/pages/dashboard/eventmodule/client/[id]/event-[eventId]/index.vue")
  }
]
  },
  {
    name: "dashboard-eventmodule-client-id",
    path: "/dashboard/eventmodule/client/:id()",
    meta: indexKFBdefzb0RxjmvR8_dSwdIQX_d8SuXgp3f7NxLfVWNwMeta || {},
    component: () => import("/app/app/pages/dashboard/eventmodule/client/[id]/index.vue")
  },
  {
    name: "dashboard-admin-user-management",
    path: "/dashboard/admin/user-management",
    meta: user_45management1w7QoGY7fbmyPFPyjsQDU82mPypw_HG7rTzaT9vzUe0Meta || {},
    component: () => import("/app/app/pages/dashboard/admin/user-management.vue")
  },
  {
    name: "dashboard-stock-outofstock",
    path: "/dashboard/stock/outofstock",
    meta: indexE2E0Vbc33pV7Hm4qnZqfdLpIQUEtYcAYaXSk7ckPu6AMeta || {},
    component: () => import("/app/app/pages/dashboard/stock/outofstock/index.vue")
  },
  {
    name: "dashboard-tools-emm-flow",
    path: "/dashboard/tools/emm-flow",
    meta: indexPEHsEG1vGqPO7LMvkTXIOI3QvhAVMlemZ6x_haeWzqsMeta || {},
    component: () => import("/app/app/pages/dashboard/tools/emm-flow/index.vue")
  },
  {
    name: _91userid_93L6E0Ns8RvDtjdqUwfdtJPSQ_kJY9MokPUepF_wdXCTcMeta?.name,
    path: "/dashboard/webusers/:clientid()/:userid()",
    component: () => import("/app/app/pages/dashboard/webusers/[clientid]/[userid].vue"),
    children: [
  {
    name: "dashboard-webusers-clientid-userid-order-orderid",
    path: "order/:orderid()",
    component: () => import("/app/app/pages/dashboard/webusers/[clientid]/[userid]/order/[orderid].vue")
  },
  {
    name: "dashboard-webusers-clientid-userid",
    path: "",
    component: () => import("/app/app/pages/dashboard/webusers/[clientid]/[userid]/index.vue")
  }
]
  },
  {
    name: "dashboard-orders-orderid",
    path: "/dashboard/orders/:orderid()",
    component: () => import("/app/app/pages/dashboard/orders/[orderid]/index.vue")
  },
  {
    name: "dashboard-eventmodule",
    path: "/dashboard/eventmodule",
    meta: indexDjkFYUWD0bQAoG4VCBuKPVK7k2j8q3rNpOM0hhuod00Meta || {},
    component: () => import("/app/app/pages/dashboard/eventmodule/index.vue")
  },
  {
    name: "dashboard-orders",
    path: "/dashboard/orders",
    component: () => import("/app/app/pages/dashboard/orders/index.vue")
  },
  {
    name: "dashboard-pointshop",
    path: "/dashboard/pointshop",
    meta: indexMhkj4tVpyBiKL2bnJlPufVmTCai12fhGOtHtNbiDRngMeta || {},
    component: () => import("/app/app/pages/dashboard/pointshop/index.vue")
  },
  {
    name: "dashboard-seo",
    path: "/dashboard/seo",
    meta: seoqigIGxALwNFWRbXYw3xTGEk0fsfmvrIukDqCsrxg5uMMeta || {},
    component: () => import("/app/app/pages/dashboard/seo.vue"),
    children: [
  {
    name: "dashboard-seo-domain-keywords-id",
    path: ":domain()/keywords/:id()",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/keywords/[id].vue")
  },
  {
    name: "dashboard-seo-domain-pages-url",
    path: ":domain()/pages/:url()",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/pages/[url].vue")
  },
  {
    name: "dashboard-seo-domain-keyword-lookup",
    path: ":domain()/keyword-lookup",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/keyword-lookup.vue")
  },
  {
    name: "dashboard-seo-domain-keywords",
    path: ":domain()/keywords",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/keywords/index.vue")
  },
  {
    name: "dashboard-seo-domain-overview",
    path: ":domain()/overview",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/overview.vue")
  },
  {
    name: "dashboard-seo-domain-pages",
    path: ":domain()/pages",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/pages/index.vue")
  },
  {
    name: "dashboard-seo-domain-settings",
    path: ":domain()/settings",
    meta: settingst1x9BoSz_EDaMmivH1DyfFMJsYHhYNMDsNmAX4FLQowMeta || {},
    component: () => import("/app/app/pages/dashboard/seo/[domain]/settings.vue")
  },
  {
    name: "dashboard-seo-domain-tags",
    path: ":domain()/tags",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/tags.vue")
  },
  {
    name: "dashboard-seo-domain",
    path: ":domain()",
    component: () => import("/app/app/pages/dashboard/seo/[domain]/index.vue")
  }
]
  },
  {
    name: serversgumUUtIKuH0z6MvCnlaIRMTRFhfox0xj7iHzf8koPSQMeta?.name,
    path: "/dashboard/servers",
    meta: serversgumUUtIKuH0z6MvCnlaIRMTRFhfox0xj7iHzf8koPSQMeta || {},
    component: () => import("/app/app/pages/dashboard/servers.vue"),
    children: [
  {
    name: "dashboard-servers-webpage-statistics-build-website-pageid",
    path: "webpage-statistics/:build()/:website()/:pageid()",
    component: () => import("/app/app/pages/dashboard/servers/webpage-statistics/[build]/[website]/[pageid].vue")
  },
  {
    name: "dashboard-servers-error-reports",
    path: "error-reports",
    component: () => import("/app/app/pages/dashboard/servers/error-reports/index.vue")
  },
  {
    name: "dashboard-servers-overview",
    path: "overview",
    component: () => import("/app/app/pages/dashboard/servers/overview/index.vue")
  },
  {
    name: "dashboard-servers-webpage-statistics",
    path: "webpage-statistics",
    component: () => import("/app/app/pages/dashboard/servers/webpage-statistics/index.vue")
  },
  {
    name: "dashboard-servers",
    path: "",
    component: () => import("/app/app/pages/dashboard/servers/index.vue")
  }
]
  },
  {
    name: "dashboard-tools",
    path: "/dashboard/tools",
    meta: indexqfQk3C5z_nf8Nlz1kffHvi0ZI3PleMffGJd4uKhAom8Meta || {},
    component: () => import("/app/app/pages/dashboard/tools/index.vue")
  },
  {
    name: "dashboard-translations",
    path: "/dashboard/translations",
    component: () => import("/app/app/pages/dashboard/translations/index.vue")
  },
  {
    name: "dashboard-webevents",
    path: "/dashboard/webevents",
    meta: indexHIIz5a6XrnVNDnYNer2S3TfuCfDTyCFLRX_fA_cl9DYMeta || {},
    component: () => import("/app/app/pages/dashboard/webevents/index.vue")
  },
  {
    name: "dashboard-webforms",
    path: "/dashboard/webforms",
    meta: webformsUYH_eHnzo7R84kr3YuMlYoI0kpGh88Q0axhL1l881q8Meta || {},
    component: () => import("/app/app/pages/dashboard/webforms.vue"),
    children: [
  {
    name: "dashboard-webforms-domain-editform-id",
    path: ":domain()/editform/:id()",
    meta: indexpcFc3gBS2PuENZwWx1mByHJmTzlp3KOcHEtE_ZfWbIUMeta || {},
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/editform/[id]/index.vue")
  },
  {
    name: "dashboard-webforms-domain-submitted-webforms-id",
    path: ":domain()/submitted-webforms/:id()",
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/submitted-webforms/[id].vue")
  },
  {
    name: "dashboard-webforms-domain-webform-id",
    path: ":domain()/webform/:id()",
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/webform/[id]/index.vue")
  },
  {
    name: "dashboard-webforms-domain-create",
    path: ":domain()/create",
    meta: createQbAnIyEL7yN7cAvlYpgbfP0NsdrZvniS1IPmDLjUDToMeta || {},
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/create.vue")
  },
  {
    name: "dashboard-webforms-domain-overview",
    path: ":domain()/overview",
    meta: overviewfZEVZ2jwqsX9z5R3B3eblnhHp_ZbvOVaoMyxow3hBtEMeta || {},
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/overview.vue")
  },
  {
    name: "dashboard-webforms-domain-settings",
    path: ":domain()/settings",
    meta: settingsq9qUg6pPz2ImpTb4cf28u_KBc7ZXuMnAoyrS_OluSKIMeta || {},
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/settings.vue")
  },
  {
    name: "dashboard-webforms-domain-webform",
    path: ":domain()/webform",
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/webform/index.vue")
  },
  {
    name: "dashboard-webforms-domain",
    path: ":domain()",
    component: () => import("/app/app/pages/dashboard/webforms/[domain]/index.vue")
  }
]
  },
  {
    name: "dashboard-webpages",
    path: "/dashboard/webpages",
    meta: indexzp_GCrkg6qjznHfxptlM1q6d6cwdEzDVNjWeftJFcMIMeta || {},
    component: () => import("/app/app/pages/dashboard/webpages/index.vue")
  },
  {
    name: "dashboard-webusers",
    path: "/dashboard/webusers",
    component: () => import("/app/app/pages/dashboard/webusers/index.vue")
  },
  {
    name: "dashboard-client-clientID-mail-builder-edit-id",
    path: "/dashboard/client-:clientID()/mail-builder/edit-:id()",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/mail-builder/edit-[id]/index.vue")
  },
  {
    name: "dashboard-client-clientID-mail-builder",
    path: "/dashboard/client-:clientID()/mail-builder",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/mail-builder/index.vue")
  },
  {
    name: "dashboard-client-clientID-screens",
    path: "/dashboard/client-:clientID()/screens",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/screens.vue"),
    children: [
  {
    name: "dashboard-client-clientID-screens-newssetup",
    path: "newssetup",
    meta: newssetupZh354pPfdci5Brk8qO89dczyF7U3v_KpbZUIwrQ8_qgMeta || {},
    component: () => import("/app/app/pages/dashboard/client-[clientID]/screens/newssetup.vue"),
    children: [
  {
    name: "dashboard-client-clientID-screens-newssetup-news",
    path: "news",
    meta: newspdsd_Mn_sRdtTgiNi_X9fmbm0Ucxcq9RSRXk8rlwWnkMeta || {},
    component: () => import("/app/app/pages/dashboard/client-[clientID]/screens/newssetup/news.vue")
  }
]
  },
  {
    name: "dashboard-client-clientID-screens-webevents",
    path: "webevents",
    meta: webeventsd0V7NoTGyasG7x9BTnKAPB2ROMPyBjxb4jSZhNnPYw0Meta || {},
    component: () => import("/app/app/pages/dashboard/client-[clientID]/screens/webevents.vue")
  }
]
  },
  {
    name: "dashboard-client-clientID-websites",
    path: "/dashboard/client-:clientID()/websites",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/websites.vue")
  },
  {
    name: "dashboard-client-clientID-webusers",
    path: "/dashboard/client-:clientID()/webusers",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/webusers.vue")
  },
  {
    name: "dashboard-client-clientID-website-websiteID-webpages",
    path: "/dashboard/client-:clientID()/website-:websiteID()/webpages",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/website-[websiteID]/webpages.vue")
  },
  {
    name: "dashboard-client-clientID-website-websiteID-webpage-webpageID-content-contentID",
    path: "/dashboard/client-:clientID()/website-:websiteID()/webpage-:webpageID()/content-:contentID()",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/website-[websiteID]/webpage-[webpageID]/content-[contentID]/index.vue")
  },
  {
    name: "dashboard-client-clientID-website-websiteID-webpage-webpageID",
    path: "/dashboard/client-:clientID()/website-:websiteID()/webpage-:webpageID()",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/website-[websiteID]/webpage-[webpageID]/index.vue")
  },
  {
    name: "dashboard-client-clientID-website-websiteID",
    path: "/dashboard/client-:clientID()/website-:websiteID()",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/website-[websiteID]/index.vue")
  },
  {
    name: "dashboard-client-clientID-webuser-userID",
    path: "/dashboard/client-:clientID()/webuser-:userID()",
    component: () => import("/app/app/pages/dashboard/client-[clientID]/webuser-[userID]/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/app/pages/dashboard/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: LoginJvrAfz0lsVTnrj7IU6q5pajc3WOjYSVdzcpFNnOZZOIMeta || {},
    component: () => import("/app/app/pages/Login.vue")
  },
  {
    name: "pharmanord.dk",
    path: "/pharmanord.dk",
    component: () => import("/app/app/pages/pharmanord.dk/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  }
]